<template>
  <div class="items3">
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <DetalleComprobanteTable :detalles="detalles" :headers="computedHeaders">
      
      <template #cantidad="{ item }">
        <div v-if="edit" class="rect-quantity-container d-flex align-center">
          <button 
            type="button"
            class="rect-btn" 
              @click="item.decrementar()"

            :disabled="item.cantidad <= 1"
          >
            <v-icon x-small :color="item.cantidad > 1 ? 'white' : 'rgba(255,255,255,0.1)'">
              mdi-minus
            </v-icon>
          </button>
          
          <input
            type="number"
            class="rect-input"
            v-model.number="item.cantidad"
              @blur="item.normalizarCantidad()"

            @focus="$event.target.select()"
            min="1"
          />
          
          <button type="button" class="rect-btn" @click="item.incrementar()">
            <v-icon x-small color="white">mdi-plus</v-icon>
          </button>
        </div>
        <span v-else class="font-weight-bold">{{ item.cantidad }}</span>
      </template>
         <template #descripcion_concepto="{ item }">
          <div class="d-flex flex-column py-0">
            <span class="product-name">{{ item.descripcion_concepto }}</span>
          </div>
        </template>

      <template #precioUnitario="{ item }">
        <div v-if="edit" style="max-width: 140px">
          <v-text-field
            v-model.number="item.precioUnitario"
            type="number"
            dense
            hide-details
            outlined
            prefix="$"
            class="custom-rectangular-input"
            @change="cerrarPrecio(item)"
            @focus="$event.target.select()"
          />
        </div>
        <span v-else class="grey--text text--lighten-1">$ {{ item.precioUnitario }}</span>
      </template>

      <template v-if="withIva" #vat_type="{ item }">
        <AlicuotaIvaSelect
          :isEdit="edit"
          :iva="item.vat_type"
          @update:iva="item.vat_type = $event"
        />
      </template>

      <template #subTotal="{ item }">
        <span class="white--text font-weight-bold">$ {{ item.subtotalSinIva }}</span>
      </template>

      <template #actions="{ item }">
        <v-btn icon color="error" x-small @click="eliminar(item)">
          <v-icon small>mdi-delete-outline</v-icon>
        </v-btn>
      </template>
    </DetalleComprobanteTable>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DetalleComprobanteTable from "@/components/comprobante/DetalleComprobanteTable.vue";
import DetalleMixin from "@/mixins/comprobantes/DetalleComprobanteMixin";
import AlicuotaIvaSelect from "@/components/util/AlicuotaIvaSelect.vue";

export default {
  name: "FacturaCompraDetallesList",
  components: { DetalleComprobanteTable, AlicuotaIvaSelect },
  mixins: [DetalleMixin],
  props: {
    detalles: { type: Array, required: true },
    edit: { type: Boolean, default: true },
    withIva: { type: Boolean, default: true }
  },
  data() {
    return {
      snack: false,
      snackColor: "",
      snackText: "",
      headers: [
        { text: "Descripción", value: "descripcion_concepto" },
        { text: "Cantidad", value: "cantidad", width: "130px", align: 'center' },
        { text: "Precio unitario", value: "precioUnitario", width: "150px" },
        { text: "IVA", value: "vat_type", width: "120px" },
        { text: "Subtotal", value: "subTotal", align: 'right' },
        { text: "Acciones", value: "actions", sortable: false, align: 'center' }
      ]
    };
  },
  computed: {
    ...mapState("pedidos", ["error_detalle_repetido"]),
    computedHeaders() {
      return this.headers.filter(h => {
        if (!this.edit && h.value === "actions") return false;
        if (!this.withIva && h.value === "vat_type") return false;
        return true;
      });
    }
  },
  methods: {
    onSave(text, color = "success") {
      this.snack = true;
      this.snackColor = color;
      this.snackText = text;
    },
    validarYCerrarCantidad(item) {
      // Si es nulo, vacío, menor o igual a 0, forzamos a 1
      if (!item.cantidad || item.cantidad <= 0) {
        item.cantidad = 1;
        this.onSave('La cantidad mínima es 1', 'error');
      } else {
        this.onSave('Cantidad actualizada');
      }
      // Llamamos al método del mixin para recalcular si existe
      if (this.cerrarCantidad) {
        this.cerrarCantidad(item);
      }
    },
    cerrarPrecio(item) {
      if (!item.precioUnitario || item.precioUnitario < 0) {
        item.precioUnitario = 0;
      }
      this.onSave('Precio actualizado');
    }
  }
};
</script>

<style scoped lang="scss">
.rect-quantity-container {
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 4px;
  padding: 0 4px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: inline-flex;
  min-width: 110px;
  height: 36px;
  justify-content: space-between;

  &:focus-within {
    border-color: var(--v-primary-base); /* Resalta el borde al entrar al input */
  }

  .rect-btn {
    width: 28px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    outline: none;

    &:hover:not(:disabled) { background: rgba(255, 255, 255, 0.05); }
    &:disabled { cursor: not-allowed; opacity: 0.5; }
  }

  .rect-input {
    width: 45px;
    text-align: center;
    color: white;
    font-weight: 600;
    background: transparent;
    border: none;
    outline: none;
    font-size: 0.9rem;
    &::-webkit-inner-spin-button, &::-webkit-outer-spin-button { 
      -webkit-appearance: none; 
      margin: 0;
    }
  }
}

.custom-rectangular-input {
  ::v-deep .v-input__slot {
    min-height: 36px !important;
    background-color: rgba(255, 255, 255, 0.03) !important;
  }
  ::v-deep input {
    font-size: 0.9rem;
    font-weight: 600;
  }
}

::v-deep .v-data-table td {
  padding: 8px !important;
}
</style>